// extracted by mini-css-extract-plugin
module.exports = {"modal":"sort-modal_modal__oHkIV"};